export function buildSchemeDialogueRouteQuery({
  chatKind = '',
  entityId = '',
  sourcePage = '',
  receiverUserId = '',
  receiverPhone = '',
  receiverName = '',
  prefillText = '',
  sendType = '',
  receiveType = ''
} = {}) {
  return {
    chatKind: chatKind || '',
    entityId: entityId ? String(entityId) : '',
    sourcePage: sourcePage || '',
    receiverUserId: receiverUserId ? String(receiverUserId) : '',
    receiverPhone: receiverPhone || '',
    receiverName: receiverName || '',
    prefillText: prefillText || '',
    sendType: sendType || '',
    receiveType: receiveType || ''
  }
}

export function parseSchemeDialogueRouteQuery(query = {}) {
  return {
    chatKind: query.chatKind || '',
    entityId: query.entityId || '',
    sourcePage: query.sourcePage || '',
    receiverUserId: query.receiverUserId || '',
    receiverPhone: query.receiverPhone || '',
    receiverName: query.receiverName || '',
    prefillText: query.prefillText || '',
    sendType: query.sendType || '',
    receiveType: query.receiveType || ''
  }
}
